/* eslint-disable no-param-reassign */
import React from 'react';
import Moment from 'moment';
import 'moment/locale/es';
import './paquete-detalle-transporte.css';

const Tramo = (props) => {

  const getDate = (value, format, returnedText, appendedText = '') => {
    if (
      value === null
            || value === '0001-01-01T00:00:00'
      || value === undefined
    ) {
      return returnedText;
    }

    if (format.toUpperCase().includes('H') && value.includes('00:00:00')) {
      return returnedText;
    }

    return `${Moment(value).format(format)} ${appendedText}`;
  };

  const getDuration = (start, end) => {

    start = Moment(start);
    end = Moment(end);

    const duracion = Moment.duration(start.diff(end));
    const horas = Moment.duration(duracion).asHours();
    const minutos = Moment.duration(duracion).minutes();

    return `${Math.floor(horas)}h ${minutos}m`;

  };

  const diaSalida = getDate(props.datos.segmentoPrincipal.fechaSalida, 'dddd', '');
  const diaLlegada = getDate(props.datos.segmentoPrincipal.fechaLlegada, 'dddd', '');
  const fechaLlegada = getDate(props.datos.segmentoPrincipal.fechaLlegada, 'LL', '');
  const fechaSalida = getDate(props.datos.segmentoPrincipal.fechaSalida, 'LL', '');
  const horaSalida = getDate(props.datos.segmentoPrincipal.horaSalida, 'HH:mm A', '--:-- ');
  const horaLlegada = getDate(props.datos.segmentoPrincipal.horaLlegada, 'HH:mm A', '--:-- ');
  const duracion = getDuration(props.datos.segmentoPrincipal.horaLlegada, props.datos.segmentoPrincipal.horaSalida);
  const mensajeEscalas = props.datos.escalas === 0
    ? 'Directo'
    : props.datos.escalas > 1 ? `${props.datos.escalas} escalas` : `${props.datos.escalas} escala`;

  // eslint-disable-next-line no-unused-vars
  const duration = duracion === '0h 0m'
    ? ''
    : (
      <div className='duracion-viaje'>
        <span>Duración:</span>
        {' '}
        <span style={{ display: 'inline-block' }}>{duracion}</span>
      </div>
    );

  return (
    <span>
      <div className='titulo-principal-viajes'>
        {' '}
        {props.titulo}
        {' '}
      </div>
      <div className='row'>
        <div className='col-lg-10'>
          <div className='fecha-salida-viaje'>
            <div className='row'>
              <div className='col-lg-6 col-md-6 col-xs-6'>
                {fechaSalida}
              </div>
              <div className='col-lg-6 col-md-6 col-xs-6'>
                <span className='pull-right'>{fechaLlegada}</span>
              </div>
            </div>

          </div>
          <div className='contenedor-info-viaje'>
            <span className='info text-center'>
              <div className='dia'>
                Sale
                {' '}
                {diaSalida}
              </div>
              <div className='hora-destino '>
                {horaSalida}
                <b>
                  <span className='iata color-dinamico'>
                    {' '}
                    {props.datos.segmentoPrincipal.aeropuertoOrigen}
                    {' '}
                  </span>
                </b>
              </div>
            </span>
            <span className='escalas'>
              <hr />
            </span>
            <span className='info text-center'>
              <div className='dia'>
                Llega
                {' '}
                {diaLlegada}
              </div>
              <div className='hora-destino'>
                {horaLlegada}
                <b>
                  <span className='iata color-dinamico'>
                    {' '}
                    {props.datos.segmentoPrincipal.aeropuertoLlegada}
                    {' '}
                  </span>
                </b>
              </div>
            </span>
          </div>

        </div>
        <div className='col-lg-2'>
          <div className='information-transporte'>
            <div>
              <span>Empresa: </span>
              <span>{props.transporte.nombreLineaAerea}</span>
            </div>
            <div><b>{mensajeEscalas}</b></div>
          </div>
        </div>
      </div>
    </span>
  );
};

export default Tramo;
